module.exports = __webpack_public_path__ + "img/loding.24388114.gif";